import Navaparkhome1 from '../../Media/homeimages/Lyndon 19.webp'
import Navaparkhome2 from '../../Media/homeimages/Lyndon 19.webp'





const Navaparkhomeimages =[
Navaparkhome1,Navaparkhome2
]

export default Navaparkhomeimages;